import { render, staticRenderFns } from "./des.vue?vue&type=template&id=7f6faef3&scoped=true"
import script from "./des.vue?vue&type=script&lang=js"
export * from "./des.vue?vue&type=script&lang=js"
import style0 from "./des.vue?vue&type=style&index=0&id=7f6faef3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6faef3",
  null
  
)

export default component.exports